import { Flex, Text } from '@chakra-ui/react'

interface ErrorViewProps {
  message: string
}

export const ErrorView = ({ message }: ErrorViewProps): JSX.Element => (
  <Flex
    className="h-full w-full absolute inset-0"
    justifyContent="center"
    alignItems="center"
    gap={3}
  >
    <Text color="red.500">Error: {message}</Text>
  </Flex>
) 